import React from 'react';
import { Skeleton } from '../../../../components/ui/Skeleton';

// Skeletons SHAPE-MATCHED para los tabs de Calidad de entregas.
// Mismo patrón que el `FirstLoadSkeleton` de AiPerformanceTab (bloques de KPI
// + bloque de chart/tabla), compuesto desde el primitivo `ui/Skeleton`
// (theme-aware, respeta dark mode y AA).

// Bloque genérico con borde, para chart/tabla.
export function SkeletonPanel({ height = 320 }) {
  return (
    <Skeleton
      className="w-100 rounded-lg"
      style={{ height }}
    />
  );
}

// Fila de N KPI cards (default 4) imitando `KpiCard`.
export function KpiRowSkeleton({ count = 4 }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-lg border border-border bg-bg p-4">
          <div className="flex justify-between items-start gap-2">
            <div className="grid gap-2 flex-1">
              <Skeleton className="h-3 w-2/3" />
              <Skeleton className="h-6 w-1/2" />
              <Skeleton className="h-3 w-1/3" />
            </div>
            <Skeleton className="h-9 w-9 rounded-md" />
          </div>
        </div>
      ))}
    </div>
  );
}

// Tabla genérica dentro de un Card (cabecera + filas) para tabs tipo tabla.
export function CardTableSkeleton({ rows = 8, columns = 5, height = 'auto' }) {
  return (
    <div className="rounded-lg border border-border bg-bg overflow-hidden" style={{ height }}>
      <div className="d-flex align-items-center" style={{ gap: '1rem', padding: '0.75rem 1rem', background: 'var(--surface-secondary)' }}>
        {Array.from({ length: columns }).map((_, c) => (
          <div key={c} style={{ flex: 1 }}>
            <Skeleton className="h-3 w-3/4" />
          </div>
        ))}
      </div>
      <div className="divide-y divide-border">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="d-flex align-items-center" style={{ gap: '1rem', padding: '0.75rem 1rem' }}>
            {Array.from({ length: columns }).map((_, c) => (
              <div key={c} style={{ flex: 1 }}>
                <Skeleton className="h-4" style={{ width: `${50 + ((r + c) % 4) * 12}%` }} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
